export default "__VITE_ASSET__6884fb16__"